import React, { useState } from 'react'
import { hashHistory } from 'react-router';
import Grid from "@material-ui/core/Grid";
import { useStyle } from "./Style";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Button from '@mui/material/Button';
import Claims from '../CustomerClaimsTable/Claims';
import { getPartnerGuid } from '../../../../../lib/access.es6';



const ClaimInitiationWrapper = (props) => {
  const steps =  ['Step 1', 'Step 2', 'Step 3', 'Step 4', 'step 5', 'Step 6']
  const partnerGuid = getPartnerGuid();

  const tabIndex = {
    selectPolicy: 0,
    selectMember: 1,
    AdditionalDetails: 2,
    ClaimLogging: 3,
    claimSummary: 4,
    claimDetails: 5,
  };

  const classes = useStyle();
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleStep = step => () => {
    setActiveStep(step);
  };

  const getLabel = () => {
  if (completedSteps() === totalSteps() - 1)
    return "All Done";

  if (activeStep === tabIndex.ClaimLogging)
    return "View  Claim Summary";
  if (activeStep === tabIndex.claimSummary)
    return "Submit Claim ";
  return "Next";
};

  const isBackDisabled = () => {
    // Disable back button on first step
    return activeStep === 0;
  };

  const isDisabled = () => {
    if (activeStep === tabIndex.selectPolicy && !props.eventQuote) return true;
    
    const selectedBenefits = props.claimPayload.claimInitiationPayload.benefits;
    if (activeStep === tabIndex.selectMember &&
        (!props.eventQuote ||
         !props.claimPayload.claimInitiationPayload.member ||
         !selectedBenefits ||
         selectedBenefits.length === 0)) {
      return true;
    }
    // Retest item 19: a member who already has a claim in flight cannot have a
    // second one logged. SelectMember reports this up as member_has_open_claim.
    if (activeStep === tabIndex.selectMember && props.memberHasOpenClaim) {
      return true;
    }

    // Additional Details validation for hospitalization benefits
    if (props.hasHospiCashAccidentBenefit || props.hasHospiCashIllnessBenefit) {
      if (activeStep === tabIndex.AdditionalDetails &&
          (!props.admissionDate ||
           !props.dischargeDate ||
           !props.hospital_attended ||
           !props.cause_of_hospitilization ||
           !props.inpatient_number ||
           !props.number_of_days_in_hospital)) {
        return true;
      }
    }

    // Additional Details validation for funeral benefits
    if (props.showFuneralDetails || props.hasFuneralNaturalDeath || props.hasFuneralAccidentalDeath ) {
      if (activeStep === tabIndex.AdditionalDetails) {
        if (!props.dateOfDeath || !props.funeral_home_name) {
          return true;
        }
        // ISS-053: the death certificate is often not yet issued when a claim
        // is registered, so for OMK it must not block capture. Other partners
        // keep the existing requirement.
        if (partnerGuid !== 'omk' && !props.death_certficate_number) {
          return true;
        }
        // ISS-054: cause of death drives assessment and is a required
        // dropdown on the customer journey, so require it here too and keep
        // the two capture paths consistent.
        if (partnerGuid === 'omk' && !props.cause_of_death) {
          return true;
        }
        // Retest item 12: the exact cause — the specific illness or the nature of
        // the accident — is mandatory on the customer journey. Without it here a
        // back-office claim reached assessment with only "Natural"/"Accidental".
        if (
          partnerGuid === 'omk' &&
          (!props.cause_of_death_detail ||
            !String(props.cause_of_death_detail).trim())
        ) {
          return true;
        }
      }
    }
    if(props.isMalawiFuneralBenefits){
 if (activeStep === tabIndex.AdditionalDetails &&
          (!props.dateOfDeath || !props.funeral_home_name)) {
        return true;
      }
    }
    // Claim Logging validation
    if (activeStep === tabIndex.ClaimLogging) {
      const claimantData = props.claimPayload;

      // Base required fields for all benefit types
      if (!claimantData.claimant_full_name ||
          !claimantData.claimant_id_number ||
          !claimantData.claimant_phone_number ||
          !claimantData.claimant_relationship_to_patient) {
        return true;
      }

      // Nobody can claim for their own death. ClaimLoggingDetails reports the match
      // up as claimant_is_deceased and shows which detail matched; this is what
      // stops the claim actually being submitted. The flag is only ever set for the
      // partners that run the check, so no other partner's flow changes — it used to
      // be read inside the old_mutual_malawi branch below, which never runs in this
      // app (Malawi routes to its own claim initiation), so for OMK the warning
      // appeared but Next stayed enabled.
      if (claimantData.claimant_is_deceased) {
        return true;
      }

      // Additional OMK-specific requirements for funeral benefits
      if ((props.hasFuneralNaturalDeath || props.hasFuneralAccidentalDeath) && partnerGuid === 'omk' ) {
        if (!claimantData.claimant_email || !claimantData.claimant_payment_option) {
          return true;
        }

        // Validate based on payment option for OMK
        if (claimantData.claimant_payment_option === "Mpesa") {
          if (!claimantData.claimant_mpesa_phone_number) {
            return true;
          }
        } else if (claimantData.claimant_payment_option === "Bank") {
          if (!claimantData.claimant_bank_account_number || !claimantData.claimant_bank_name) {
            return true;
          }
        }
      }
      if (partnerGuid === 'old_mutual_malawi') {
        if (!claimantData.claimant_email) {
          return true;
        }
        if (claimantData.claimant_is_deceased) {
          return true;
        }
      }

    return false;
    }
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);

    if(activeStep === tabIndex.ClaimLogging) {
      props.handleClaimSummary();
      // return
    }



    if(activeStep === tabIndex.claimSummary) {
      props.handleInitiateClaim();
      // return
    }

    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  const getClaimComponents = () => {

    if (activeStep === tabIndex.selectPolicy) return {
      component: props.components.SelectPolicy
    }
    if (activeStep === tabIndex.selectMember) return {
      component: props.components.SelectMember
    }
    if (activeStep === tabIndex.ClaimLogging) return {
      component: props.components.ClaimLoggingDetails
    }

    if (activeStep === tabIndex.AdditionalDetails) return {
      component: props.components.AdditionalDetails
    }

    if (activeStep === tabIndex.claimSummary) return {
      component: props.components.ClaimSummary
    }

    if (activeStep === tabIndex.claimDetails) return {
      component: props.components.ClaimDetails
    }
  }

  const renderClaimComponent = () => {
    const claimComponent = getClaimComponents();
    return <div>
      <Box
        component="form"
        sx={{
          '& .MuiTextField-root': { m: 1, width: '25ch' },
        }}
        noValidate
        autoComplete="off"
      >
        <>
          {claimComponent.component}
        </>
      </Box>
    </div>
  }
  return (
    <>
      <Grid item xs={12} md={9} sm={9}>
        <section className={classes.ClaimInitiationWrapper}>
          <Box sx={{ width: '100%' }}>
            <div className={classes.stepperlabelwrapper}>
              <Stepper  activeStep={activeStep}>
                {steps.map((label, index) => (
                  <Step key={label} completed={completed[index]} sx={{
                    '& .MuiStepLabel-root .Mui-completed': {
                      color: '#75A85E', // circle color (COMPLETED)
                    },
                    '& .MuiStepLabel-root .Mui-active': {
                      color: '#032a37', // circle color (ACTIVE)
                    },
                    '& .MuiStepLabel-root .Mui-active .MuiStepIcon-text': {
                      fill: '#fff', // circle's number (ACTIVE)
                    },
                  }}>
                    <StepButton color="inherit" onClick={handleStep(index)}>
                      {label}
                    </StepButton>
                  </Step>
                ))}
              </Stepper>
            </div>

            <div>
              {allStepsCompleted() ? (
                <>
                  <div className={classes.claimnavigationbtn} style={{ textAlign: 'center' }}>
                    <p >
                      What would you like to do next
                    </p>
                    <br/>
                    <br/>
                    <Button
                      variant="contained"
                      size="large"
                      onClick={handleReset}
                    >Generate Another Claim</Button>
                    <Button
                      variant="contained"
                      size="large"
                      onClick={()=> hashHistory.push(`admin/claim-processing-v2/${props.createdClaim ? props.createdClaim.guid : ''}`)}
                    // className={classes.viewquote}
                    >View Claim</Button>
                  </div>
                </>
              ) : (
                <>
                  <div className={classes.claimsinitiatewrapper}>

                    {renderClaimComponent()}
                  </div>
                  <div className={classes.claimnavigationbtn}>
                    <Button
                      disabled={isBackDisabled()} 
                      onClick={handleBack}
                      className={classes.backbtn}
                      variant="contained"
                      color="primary"
                      size="large"
                    >
                      Back
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      onClick={handleComplete}
                      disabled={isDisabled()}
                    >
                      { getLabel()}
                    </Button>
                  </div>
                </>
              )}
            </div>


          </Box>
        </section>
        <section>
          <Claims customerClaimsDcp={props.customerClaimsDcp}/>
        </section>
      </Grid>
    </>
  )
}

export default ClaimInitiationWrapper